
export { fonts } from "/home/jenkins/agent/workspace/web-sunrise-prod/web-sunrise-consumer-deploy-prod/libs/shared/themes/src/lib/sunrise/fonts/index.ts"